$(document).ready(function () {
  // Tabs
  $('.product-tabs-content').first().addClass('is-active')

  $(document).on('click', '.product-tabs__tab', function (e) {
    e.preventDefault()
    var index = $(this).index()
    $(this).addClass('is-active').siblings().removeClass('is-active')
    $(this)
      .closest('.product__tabs')
      .find('.product-tabs-content')
      .removeClass('is-active')
      .eq(index)
      .addClass('is-active')
  })

  // Tabs auto-rotation
  var isTabsHovered = false

  $('.product__tabs')
    .on('mouseenter', function () {
      isTabsHovered = true
    })
    .on('mouseleave', function () {
      isTabsHovered = false
    })

  setInterval(function () {
    if (isTabsHovered || window.innerWidth <= 479) return
    var $tabs = $('.product-tabs__tab')
    if (!$tabs.length) return
    var $active = $tabs.filter('.is-active')
    var nextIdx = ($tabs.index($active) + 1) % $tabs.length
    $tabs.eq(nextIdx).trigger('click')
  }, 10000)

  // FAQ accordion + visual sync
  $('.product-tabs-content').each(function () {
    $(this)
      .find('.faq-item')
      .first()
      .addClass('is-active')
      .find('.faq-item__body')
      .show()
    $(this).find('.tab-content__illustration').first().addClass('is-active')
  })

  $(document).on('click', '.faq-item__head', function () {
    var $item = $(this).closest('.faq-item')
    var $content = $item.closest('.tab-content')
    var index = $content.find('.faq-item').index($item)

    if ($item.hasClass('is-active')) return

    $content
      .find('.faq-item')
      .removeClass('is-active')
      .find('.faq-item__body')
      .slideUp(300)
    $item.addClass('is-active').find('.faq-item__body').slideDown(300)

    $content.find('.tab-content__illustration').removeClass('is-active')
    $content.find('.tab-content__illustration').eq(index).addClass('is-active')
  })

  // Burger menu
  $('.btn-burger').on('click', function () {
    $(this).toggleClass('is-active')
    $('html').toggleClass('is-ovh')
    $('body').toggleClass('menu-open')
    $('.mobile-menu').toggleClass('is-active')
  })

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.mobile-menu, .btn-burger').length) {
      $('.btn-burger').removeClass('is-active')
      $('html').removeClass('is-ovh')
      $('body').removeClass('menu-open')
      $('.mobile-menu').removeClass('is-active')
    }
  })

  // Smooth scroll
  $(document).on('click', '[data-scroll-to]', function (e) {
    var scrollTo = $(this).attr('data-scroll-to')
    if (!scrollTo) return

    e.preventDefault()
    $('.btn-burger').removeClass('is-active')
    $('.mobile-menu').removeClass('is-active')
    $('html').removeClass('is-ovh')
    $('body').removeClass('menu-open')
    var target = $(scrollTo)
    if (target.length) {
      var headerHeight = $('.header').outerHeight() || 0
      $('html, body').animate(
        {
          scrollTop: target.offset().top - headerHeight,
        },
        600,
      )
    }
  })

  // Form
  var $wfForm = $('#wf-form-free-demo')
  var $form = $('.w-embed .form')

  if ($form.length !== 0) {
    $wfForm.closest('.form-wrapper__form').hide()

    const $submitBtn = $form.find('.btn-primary')

    const requiredFields = [
      'name',
      'last-name',
      'company-name',
      'email',
      'phone-number',
      'position',
    ]

    function isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    }

    function showError($field, message) {
      const $inpGroup = $field.closest('.inp-group')
      $field.addClass('inp-error')
      $inpGroup.find('.inp-group__error').remove()
      $inpGroup.append(`<div class="inp-group__error">${message}</div>`)
    }

    function clearError($field) {
      const $inpGroup = $field.closest('.inp-group')
      $field.removeClass('inp-error')
      $inpGroup.find('.inp-group__error').remove()
    }

    $form.on('input', '.inp-group__input, .inp-group__textarea', function () {
      clearError($(this))
    })

    $form.on('change', '.inp-group__select', function () {
      clearError($(this))
    })

    $form.on('submit', function (e) {
      e.preventDefault()
      return false
    })

    $submitBtn.on('click', async function (e) {
      e.preventDefault()

      let isValid = true
      let $firstError = null

      requiredFields.forEach((fieldName) => {
        const $field = $form.find(`[name="${fieldName}"]`)
        const value = $field.val()?.trim()

        if (!value || value === 'Please Select') {
          isValid = false
          showError($field, 'This field is required')
          if (!$firstError) $firstError = $field
        }
      })

      const $emailField = $form.find('[name="email"]')
      const emailValue = $emailField.val()?.trim()

      if (emailValue && !isValidEmail(emailValue)) {
        isValid = false
        showError($emailField, 'Please enter a valid email')
        if (!$firstError) $firstError = $emailField
      }

      var $phoneField = $form.find('[name="phone-number"]')
      var phoneValue = $phoneField.val()?.trim()
      if (phoneValue) {
        var phoneDigits = phoneValue.replace(/\D/g, '').length
        if (phoneDigits < 7 || phoneDigits > 15) {
          isValid = false
          showError($phoneField, 'Please enter a valid phone number')
          if (!$firstError) $firstError = $phoneField
        }
      }

      if (!isValid) {
        $firstError.focus()

        setTimeout(() => {
          $form.find('.inp-error').removeClass('inp-error')
          $form.find('.inp-group__error').remove()
        }, 10000)

        return
      }

      const formData = new URLSearchParams()
      formData.append('name', 'free-demo')
      formData.append('test', 'false')
      formData.append('dolphin', 'false')
      formData.append('pageId', $wfForm.attr('data-wf-page-id'))
      formData.append('elementId', $wfForm.attr('data-wf-element-id'))
      formData.append('source', window.location.href)

      const turnstileResponse = $wfForm
        .find('[name="cf-turnstile-response"]')
        .val()
      if (turnstileResponse) {
        formData.append('fields[cf-turnstile-response]', turnstileResponse)
      }

      var fields = {
        name: $form.find('[name="name"]').val()?.trim() || '',
        'last-name': $form.find('[name="last-name"]').val()?.trim() || '',
        'company-name': $form.find('[name="company-name"]').val()?.trim() || '',
        email: $form.find('[name="email"]').val()?.trim() || '',
        'phone-number': (function () {
          var num = $form.find('[name="phone-number"]').val()?.trim() || ''
          if (window.phoneIti) {
            var dialCode =
              '+' + window.phoneIti.getSelectedCountryData().dialCode
            return num ? dialCode + ' ' + num : ''
          }
          return num
        })(),
        position: $form.find('[name="position"]').val()?.trim() || '',
      }

      Object.entries(fields).forEach(([name, value]) => {
        formData.append(`fields[${name}]`, value)
      })

      try {
        $submitBtn.prop('disabled', true).text('Sending...')

        const siteId = $('html').attr('data-wf-site')
        const response = await fetch(
          'https://webflow.com/api/v1/form/' + siteId,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData.toString(),
          },
        )

        if (response.ok) {
          var calendlyUrl =
            'https://calendly.com/mark-dragin/dragin-intro' +
            '?first_name=' +
            encodeURIComponent(fields.name) +
            '&last_name=' +
            encodeURIComponent(fields['last-name']) +
            '&email=' +
            encodeURIComponent(fields.email)
          var $calendlyContainer = $('.form-wrapper__calendly')
          $calendlyContainer
            .html(
              '<iframe src="' +
                calendlyUrl +
                '" style="width:100%;height:100%;border:none"></iframe>',
            )
            .addClass('is-active')
        } else {
          throw new Error('Submission failed')
        }
      } catch (error) {
        console.error('Form submission error:', error)
      } finally {
        $submitBtn.prop('disabled', false).text('Get your free demo')
      }
    })
  }

  $('select').styler()

  // Phone input mask - only digits, spaces, dashes, parens, plus
  $(document).on('input', '[name="phone-number"]', function () {
    var cleaned = $(this)
      .val()
      .replace(/[^\d\s\-()+ ]/g, '')
    if (cleaned !== $(this).val()) {
      $(this).val(cleaned)
    }
  })

  // Subscribe form
  var $wfSub = $('#wf-form-subscribe')
  var $subForm = $('.w-embed .form-subscription')

  if ($subForm.length !== 0) {
    var $subInput = $subForm.find('.form-subscription__input')
    var $subBtn = $subForm.find('.btn-primary')

    $subInput.on('input', function () {
      $(this).removeClass('is-error')
    })

    $subBtn.on('click', async function (e) {
      e.preventDefault()

      var email = $subInput.val()?.trim()
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      if (!email || !emailRegex.test(email)) {
        $subInput.addClass('is-error')
        setTimeout(function () {
          $subInput.removeClass('is-error')
        }, 10000)
        return
      }

      var formData = new URLSearchParams()
      formData.append('name', 'subscribe')
      formData.append('test', 'false')
      formData.append('dolphin', 'false')
      formData.append('pageId', $wfSub.attr('data-wf-page-id'))
      formData.append('elementId', $wfSub.attr('data-wf-element-id'))
      formData.append('source', window.location.href)

      var turnstileResponse = $wfSub
        .find('[name="cf-turnstile-response"]')
        .val()
      if (turnstileResponse) {
        formData.append('fields[cf-turnstile-response]', turnstileResponse)
      }

      formData.append('fields[email]', email)

      try {
        $subBtn.prop('disabled', true).text('Sending...')

        var siteId = $('html').attr('data-wf-site')
        var response = await fetch(
          'https://webflow.com/api/v1/form/' + siteId,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData.toString(),
          },
        )

        if (response.ok) {
          $subForm[0].reset()
          $('.form-subscription__success').addClass('is-active')

          setTimeout(function () {
            $('.form-subscription__success').removeClass('is-active')
          }, 15000)
        } else {
          throw new Error('Subscription failed')
        }
      } catch (error) {
        console.error('Subscribe form error:', error)
      } finally {
        $subBtn.prop('disabled', false).text('Subscribe')
      }
    })
  }

  // Phone input with intl-tel-input
  var phoneInput = document.querySelector(
    '.w-embed .form [name="phone-number"]',
  )
  if (phoneInput && window.intlTelInput) {
    window.phoneIti = intlTelInput(phoneInput, {
      initialCountry: 'us',
      separateDialCode: true,
      utilsScript:
        'https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js',
    })
  }

  if (window.innerWidth <= 479) {
    if (document.querySelector('.tools__body')) {
      document.querySelectorAll('.tools__body').forEach((body) => {
        const rows = body.querySelectorAll('.tools__items')
        rows.forEach((row, i) => {
          const originals = Array.from(row.children)
          if (!originals.length) return
          const fillRow = () => {
            row
              .querySelectorAll('[data-marquee-clone]')
              .forEach((el) => el.remove())
            const containerWidth = body.offsetWidth
            let originalWidth = originals.reduce(
              (sum, el) => sum + el.offsetWidth + getMarginRight(el),
              0,
            )
            while (originalWidth < containerWidth) {
              originals.forEach((item) => {
                const clone = item.cloneNode(true)
                clone.setAttribute('data-marquee-clone', 'fill')
                clone.setAttribute('aria-hidden', 'true')
                row.appendChild(clone)
                originalWidth += clone.offsetWidth + getMarginRight(clone)
              })
            }
            const toClone = Array.from(row.children)
            toClone.forEach((item) => {
              const clone = item.cloneNode(true)
              clone.setAttribute('data-marquee-clone', 'loop')
              clone.setAttribute('aria-hidden', 'true')
              row.appendChild(clone)
            })
          }
          fillRow()
          row.classList.add('is-ready')
          let resizeTimer
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(fillRow, 200)
          })
        })
        function getMarginRight(el) {
          return parseFloat(getComputedStyle(el).marginRight) || 0
        }
      })
    }

    if (document.querySelector('.product-tabs.items-6')) {
      document
        .querySelectorAll('.product-tabs.items-6 .product-tabs__tab')
        .forEach((tab) => {
          if (tab.querySelector(':scope > .product-tabs__dec')) return
          const dec = document.createElement('div')
          dec.className = 'product-tabs__dec'
          tab.appendChild(dec)
        })
    }
  }
})
